import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiPath } from 'src/app/configs/api-paths';
import { BaseResponse } from 'src/app/models/base-response';
import { EntityWizardResponse } from 'src/app/models/forms/entity-wizard';
import { environment } from 'src/environments/environment';
import { LogService } from '../log-service';
import { EntityAddRequest } from 'src/app/models/entity';

@Injectable({
  providedIn: 'root',
})
export class ModifyTypeWizardDataService {
  typeModificationValidation(
    request: EntityAddRequest,
    typeKind: string,
    entityKind: string,
  ): Observable<BaseResponse<EntityWizardResponse>> {
    const m = this.typeModificationValidation.name;

    const path = environment.getEndpoint(ApiPath.Types.TYPES_UPDATE_VALIDATION(typeKind, entityKind));
    LogService.info(this, m, LogService.PUT + path, null);

    const params = new HttpParams().set('typeId', request.typeId.toString()).set('entityIds', request.entityIds.join(','));

    LogService.info(this, m, LogService.REQUEST, request);
    const retVal = this.http.put<BaseResponse<EntityWizardResponse>>(path, null, { params });

    return retVal;
  }

  typeModificationUpdate(request: EntityAddRequest, typeKind: string, entityKind: string): Observable<BaseResponse<EntityWizardResponse>> {
    const m = this.typeModificationUpdate.name;

    const path = environment.getEndpoint(ApiPath.Types.TYPES_UPDATE(typeKind, entityKind));
    LogService.info(this, m, LogService.PUT + path, null);

    const params = new HttpParams().set('typeId', request.typeId.toString()).set('entityIds', request.entityIds.join(','));

    LogService.info(this, m, LogService.REQUEST, request);
    const retVal = this.http.put<BaseResponse<EntityWizardResponse>>(path, null, { params });

    return retVal;
  }
  constructor(private http: HttpClient) {}
}
